// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8fafc;
}

.dashboard-body {
  flex: 1 1;
  display: flex;
  position: relative;
}

.dashboard-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
  margin-top: 90px;
  min-height: calc(100vh - 140px); /* Account for header and footer */
}

.dashboard-main.sidebar-collapsed {
  margin-left: 80px;
}

.dashboard-content {
  flex: 1 1;
  padding: 0;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .dashboard-main {
    margin-left: 0;
  }

  .dashboard-main.sidebar-collapsed {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardLayout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B,EAAE,kCAAkC;AACrE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".dashboard-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: #f8fafc;\n}\n\n.dashboard-body {\n  flex: 1;\n  display: flex;\n  position: relative;\n}\n\n.dashboard-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin-left: 250px;\n  transition: margin-left 0.3s ease;\n  margin-top: 90px;\n  min-height: calc(100vh - 140px); /* Account for header and footer */\n}\n\n.dashboard-main.sidebar-collapsed {\n  margin-left: 80px;\n}\n\n.dashboard-content {\n  flex: 1;\n  padding: 0;\n  overflow-y: auto;\n}\n\n@media (max-width: 768px) {\n  .dashboard-main {\n    margin-left: 0;\n  }\n\n  .dashboard-main.sidebar-collapsed {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
